import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import 'leaflet/dist/leaflet.css';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react'
import store, { persistor } from "./redux/store";
import 'react-toastify/dist/ReactToastify.css';
// import 'dotenv/config'


ReactDOM.createRoot(document.getElementById('root')!).render(
  <>
    <PersistGate persistor={persistor}>
      <Provider store={store}>
        <App />
      </Provider>
    </PersistGate>
  </>,
)
